import script from "./WelcomeNotifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./WelcomeNotifications.vue?vue&type=script&setup=true&lang=ts"

import "./WelcomeNotifications.vue?vue&type=style&index=0&id=28da9314&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28da9314"]])

export default __exports__